import * as React from 'react';

const Link = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={24} height={20} {...props}>
        <g fill="none" fillRule="evenodd">
            <path fill="#FFF" d="M-1336-1184H584v4595h-1920z" />
            <g fillRule="nonzero" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2}>
                <path d="m9.364 16.5-.932.932a4.5 4.5 0 1 1-6.364-6.364l4.773-4.774a4.5 4.5 0 0 1 6.825 5.825" />
                <path d="m14.818 3.567.75-.75a4.5 4.5 0 1 1 6.364 6.364l-4.773 4.773a4.5 4.5 0 0 1-6.824-5.826" />
            </g>
        </g>
    </svg>
);
export default Link;
